"use client";

import React from "react";

function cn(...classes: Array<string | false | undefined | null>) {
  return classes.filter(Boolean).join(" ");
}

interface AuthFieldProps {
  label: string;
  placeholder: string;
  value: string;
  onChange: (v: string) => void;
  type?: string;
  icon: React.ReactNode;
  right?: React.ReactNode;
  autoComplete?: string;
  helperText?: string;
  error?: string;
  disabled?: boolean;
}

export function AuthField({
  label,
  placeholder,
  value,
  onChange,
  type = "text",
  icon,
  right,
  autoComplete,
  helperText,
  error,
  disabled = false,
}: AuthFieldProps) {
  return (
    <label className="block">
      <div className="mb-1 flex items-center justify-between">
        <span className="text-sm font-medium text-white/80">{label}</span>
      </div>
      <div className="group relative">
        <div className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-white/40">
          {icon}
        </div>
        <input
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          autoComplete={autoComplete}
          disabled={disabled}
          className={cn(
            "h-11 w-full rounded-xl border bg-white/[0.06] pl-10 pr-10",
            "text-white placeholder:text-white/35",
            error
              ? "border-amber-400/40 focus:border-amber-400/60 focus:ring-4 focus:ring-amber-500/10"
              : "border-white/10 focus:border-emerald-400/40 focus:ring-4 focus:ring-emerald-500/10",
            "outline-none transition",
            disabled && "cursor-not-allowed opacity-60"
          )}
        />
        {right ? (
          <div className="absolute right-2 top-1/2 -translate-y-1/2">{right}</div>
        ) : null}
      </div>
      {helperText && !error && (
        <div className="mt-1.5 text-xs text-white/45">{helperText}</div>
      )}
      {error && (
        <div className="mt-1.5 text-xs text-amber-400/80">{error}</div>
      )}
    </label>
  );
}

